import React from 'react'
import Button from '@components/Button'
import SVGIcon from '@components/SVGIcon'

interface ModalActionButtonProps {
  onClick: () => void
  label: string
}

const ModalActionButton: React.FC<ModalActionButtonProps> = props => {
  const { onClick, label } = props
  return (
    <Button className="modal-action-button p-x" onClick={onClick}>
      <span className="text">{label}</span>
      <SVGIcon
        className="icon chevron-icon chevron-icon--right"
        xlinkHref="#icons-chevron-down"
        alt="Chevron pointing right"
      />
    </Button>
  )
}

export default ModalActionButton
